import { render, staticRenderFns } from "./invoiceDetailStatistics.vue?vue&type=template&id=1f6a19ae"
import script from "./invoiceDetailStatistics.vue?vue&type=script&lang=js"
export * from "./invoiceDetailStatistics.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetailStatistics.vue?vue&type=style&index=0&id=1f6a19ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports